module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/feature_four-89a0646f62803be58383eeec0e92fa21.png";